import { useNavigate, Link } from 'react-router-dom';
import { TripForm } from '../components/TripForm.jsx';
import { creerVoyage } from '../lib/trips.js';

export function TripCreate() {
  const navigate = useNavigate();

  return (
    <main className="page">
      <section className="verre">
        <p className="fil">
          <Link to="/voyages">← Mes voyages</Link>
        </p>
        <h1>Nouveau voyage</h1>

        <TripForm
          libelleAction="Créer le voyage"
          onSubmit={async (donnees) => {
            const voyage = await creerVoyage(donnees);
            navigate(`/voyages/${voyage.id}`, { replace: true });
          }}
          onCancel={() => navigate('/voyages')}
        />
      </section>
    </main>
  );
}
